"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.VerticalContainer = exports.Space = exports.Input = exports.IconStyled = exports.HorizontalContainer = exports.Error = exports.DisapplyButton = exports.Disapply = exports.Button = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _palette = require("../../../styles/palette");

var _widths = require("../../../styles/widths");

var _Icon = _interopRequireDefault(require("../Icon"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

var BASE = _widths.widths.base;

var Button = _styledComponents["default"].button(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  align-items: center;\n  background-color: ", ";\n  border: ", ";\n  border-radius: 8px;\n  color: ", ";\n  color: ", ";\n  cursor: pointer;\n  display: flex;\n  font-size: 14px;\n  font-weight: ", ";\n  height: 40px;\n  padding: 1px 18px 4px;\n\n  &:focus {\n    outline: none;\n  }\n"])), _palette.palette.darkWhite, function (_ref) {
  var border = _ref.border;
  return border ? "1px solid ".concat(_palette.palette.bobBlack) : '0';
}, _palette.palette.grey, function (_ref2) {
  var border = _ref2.border;
  return border ? _palette.palette.bobBlack : _palette.palette.grey;
}, _widths.font.medium);

exports.Button = Button;
Button.displayName = 'Button';

var Disapply = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-size: 12px;\n  line-height: 1.67;\n  margin-top: ", "px;\n"])), _palette.palette.grey, BASE * 2);

exports.Disapply = Disapply;
Disapply.displayName = 'Disapply';

var DisapplyButton = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: ", ";\n  line-height: 1.67;\n"])), _palette.palette.link, _widths.font.medium);

exports.DisapplyButton = DisapplyButton;
DisapplyButton.displayName = 'DisapplyButton';

var Error = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-size: 14px;\n  font-weight: ", ";\n  margin-top: ", "px;\n"])), _palette.palette.error, _widths.font.medium, BASE);

exports.Error = Error;
Error.displayName = 'Error';

var HorizontalContainer = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: row;\n"])));

exports.HorizontalContainer = HorizontalContainer;
HorizontalContainer.displayName = 'HorizontalContainer';
var IconStyled = (0, _styledComponents["default"])(_Icon["default"])(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-top: 3px;\n"])));
exports.IconStyled = IconStyled;
IconStyled.displayName = 'IconStyled';

var Input = _styledComponents["default"].input(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  border: 1px solid ", ";\n  border-radius: 8px;\n  flex: 1;\n  font-size: 14px;\n  font-weight: ", ";\n  margin-right: 8px;\n  padding-left: 16px;\n\n  &:focus {\n    border: 1px solid ", ";\n    outline: none;\n  }\n"])), function (props) {
  return props.error ? _palette.palette.error : _palette.palette.bobBlack;
}, _widths.font.medium, _palette.palette.link);

exports.Input = Input;
Input.displayName = 'Input';

var Space = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: ", "px;\n"])), BASE);

exports.Space = Space;
Space.displayName = 'Space';

var VerticalContainer = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n"])));

exports.VerticalContainer = VerticalContainer;
VerticalContainer.displayName = 'VerticalContainer';

var Wrapper = _styledComponents["default"].div(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])([""])));

exports.Wrapper = Wrapper;
Wrapper.displayName = 'Wrapper';